"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBonus = function SvgBonus(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.573 2.24C5.833.93 5.25.658 4.824 1.424c-.426.765-1.606 3.1-3.537 7.002-.464.69-.365 1.241.297 1.653.187 1.628.351 5.12 4.989 5.12 3.092 0 4.485-1.965 4.18-5.895.002-.585.427-.878 1.274-.878M1 8.562c3.73-.75 7.063-.75 10 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.454 2.24c.74-1.31 1.322-1.582 1.749-.816.426.765 1.606 3.1 3.537 7.002.464.69.365 1.241-.297 1.653-.187 1.628-.351 5.12-4.989 5.12-3.092 0-4.485-1.965-4.18-5.895-.002-.585-.427-.878-1.274-.878m11 .136c-3.73-.75-7.063-.75-10 0"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBonus);
var _default = exports["default"] = Memo;